// Import Vue

import Vue from 'vue'
import VueRouter from 'vue-router'

import {start_eto_payout, start_claim_tpl_payout} from '@/payout.js'
import {start_eto_mapcontact} from '@/mapcontact.js'
import {start_eto_wallethist} from '@/comp/eto/Wallet.js' 

//KABINET
//import {eto_start_kabinet} from '@/kabinet.js'

import VueModal from '@kouts/vue-modal'

Object.assign( window, { 
    start_eto_payout,

    start_claim_tpl_payout,
    start_eto_mapcontact,
    start_eto_wallethist,

//KABINET
//    eto_start_kabinet,
    Vue,
    VueModal,
} )

//window.xxx = 'eto.js'

//console.log('eto.js', window.Vue)
